import "./Requests.css";
import { useState, useEffect  } from "react";
import moment from "moment";
import { Joyride } from "react-joyride";;
import ProfileSubHeaderLinks from "../../components/profileSubHeaderLinks/ProfileSubHeaderLinks.jsx";
import { getAllUserRequests } from "../../services/wisdomServices/requestService";
import { getSessionItem } from "../../utils/helper/session";
import { formatISOString } from '../../utils/helper/isoStringFormater'
import Datatable from "../../components/requestsTable/Datatable.jsx";
import { useOnboarding } from "../../context/onboardingContext.jsx";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";

/**
 * @function Requests 
 * @returns {JSX.Element} - requests management page
 */
function Requests() {
  const currentDate = new Date()
  const { runTour, goToNextPage } = useOnboarding();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth)
  const [selectedYear, setSelectedYear] = useState(currentYear)
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false);
  let user = getSessionItem("User");
  let requestStatus = ["pending","accepted","rejected"];

  
  /**
   * @function assignDataToTable
   * @param {Array<Object>} rsummary 
   */
  let assignDataToTable= (rsummary) => {
    let list = [];
    for (const item of rsummary) {
      const endTimeWithExtraMinutes = item.endTime
      ? moment.utc(item.endTime, "HH:mm")
          .format("HH:mm")
      : "";
      list.push( {
        id: item.id,
        Date : formatISOString(item.date),
        type: item.type,
        Hours : item.hours,
        Manager : item.managerName,
        ProjectID : item.projectId,
        Project: item.projectName,
        reason : item.reason,
        status : requestStatus[item.statusCode],
        approvalDate: item.approvalDate == null? '' :  formatISOString(item.approvalDate),
        startTime: item.startTime,
        endTime: endTimeWithExtraMinutes,
        rejectReasonId: item.rejectReasonId,
        rejectReason: item.rejectReason
      });
      
    }
    setData(list);
    setLoading(false)
  }
  /**
   * @async
   * @function listRequests
   * @description - fetches all user requests from the backend
   */
  const listRequests = async (month, year) => {
    try {
      setLoading(true)
      let manualTimes = [];
      let params = {
        month: month,
        year: year
      }
      manualTimes = await getAllUserRequests(user.id, params);
      assignDataToTable(manualTimes);
      
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)

    }
  }

  const handleSubmitRequest = async() => {
    await listRequests(selectedMonth, selectedYear);
  }

  const handleDateSelected = async(month, year) => {
    await listRequests(month, year)
    setSelectedMonth(month)
    setSelectedYear(year)
  }

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;

    if (
      type === "step:after" &&
      action === "next" &&
      index === steps.length - 1
    ) {
      goToNextPage();
    }
  };

  const steps = [
    {
      content: "Here you will be able to request manual time or overtime from your manager.",
      title: "Request Page",
      placement: "center",
      target: 'body'
    },
    {
      content: 'This is where you can find your requested Manual time and Overtime and their status.',
      placement: "bottom",
      target: "#step-0",
      title: "Requests"
    },
    {
      content: 'Here you will find Manual Time request form.',
      placement: "bottom",
      target: "#request-manual-time-button",
      title: "Manual Time Request"
    },
    {
      content: 'And here you will find Overtime request form.',
      placement: "bottom",
      target: "#request-overtime-button",
      title: "Overtime Request"
    },
    {
      content: 'Click here to open the FAQ and learn more about how Requests work, including common questions and helpful tips.',
      placement: "bottom",
      target: "#requests-faq",
      title: "Requests FAQ"
    },
    
  ] 

  const dialogHeader = (
    <h4>Requests FAQ</h4>
  )

  const dialogFooter = (
    <div>
        <Button 
          label="Ok" 
          icon="pi pi-check" 
          onClick={() => setVisible(false)} 
          autoFocus 
        />
    </div>
  )
   
  useEffect(() => {
    listRequests(selectedMonth, selectedYear);
  },[]);

  return (
    <div className="profileMain">
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        callback={handleJoyrideCallback}
        locale={{
          next: "Next",
          last: "Next Page",
          skip: "Skip tour",
          back: "Back"
        }}
        styles={{
          options: {
            primaryColor: "#0BADDE",
            zIndex: 10000
          },
          tooltip: {
            borderRadius: "8px"
          },
          buttonNext: {
            backgroundColor: "#0BADDE"
          }
        }}
      />
      <ProfileSubHeaderLinks />
      <div className="manual-hours" id="step-0">
        <div className="page-header-title">
          <h1 className="user-requests-header">Requests</h1>
          <Button 
            id="requests-faq"
            icon="pi pi-exclamation-circle" 
            severity="warning"
            outlined
            className="page-header-title-requests-faq"
            onClick={() => setVisible(true)}
          />
        </div>

        <Datatable data={data} onSubmitted={handleSubmitRequest} onDateSelect={handleDateSelected} loading={loading}/>

      </div>
      <Dialog 
        dismissableMask
        className="request-faq-dialog"
        visible={visible} 
        header={dialogHeader} 
        footer={dialogFooter}
        onHide={() => {if (!visible) return; setVisible(false); }}
      >
        <Accordion activeIndex={0}>
          <AccordionTab header="Payroll time is missing, I need to submit Manual Time(MT).">
            <p className="m-0">
              Before submitting MT, make sure the missing time is not attributed to idle time cards, in which case, you need to make the time cards active.
            </p>
          </AccordionTab>
          <AccordionTab header="How do Overtime (OT) submissions work?">
            <p className="m-0">
              Employees have a standard weekly cap of 40 hours. This means they are normally allowed to work up to 40 hours in a single week. However, when an employee submits an overtime (OT) request and that request is approved, the weekly cap increases by the number of OT hours approved. Once the approved hours are added, the employee is allowed to work up to the new cap for that week.
            </p>
          </AccordionTab>
        </Accordion>
      </Dialog>
    </div>
  );
}

export default Requests;
